/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { bool, string } from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import PageLoadingContainer from 'components/layouts/Navigation/PageLoadingContainer';
import { requestStateConfig } from 'components/layouts/Navigation/RequestStateConfig';
import GrantViewAccess from 'components/layouts/Preferences/GrantViewAccess/GrantViewAccess';
import {
  alertsAndNotificationsEnabled,
  grantViewAccessEnabled,
  GPCSubscriptionsEnabled,
  paperlessPageEnabled,
  beneficiariesEnabled,
} from 'services/FeatureFlags';
import { getLocationRequestStateKey } from 'state/requests/RequestStatusSelectors';
import TrustedContacts from 'components/layouts/Preferences/TrustedContacts/TrustedContacts';
import Subscriptions from 'components/layouts/Preferences/Subscriptions/Subscriptions';
import GPCSubscriptions from 'components/layouts/Preferences/Subscriptions/GPCSubscriptions';
import CustomizeAccountsView from 'components/layouts/Preferences/CustomizeAccountsView/CustomizeAccountsView';
import PreferencesUpdateContactInformation from 'components/layouts/Preferences/UpdateContactInformation/PreferencesUpdateContactInformation';
import LinkedBankAccounts from 'components/layouts/Preferences/LinkedBankAccounts/LinkedBankAccounts';
import DocumentDelivery from 'components/layouts/Preferences/DocumentDelivery/DocumentDelivery';
import PreferencesCheckwriting from 'components/layouts/Preferences/Checkwriting/PreferencesCheckwriting';
import Beneficiaries from 'components/layouts/Preferences/Beneficiaries/Beneficiaries';
import BeneficiariesV2 from 'components/layouts/Preferences/BeneficiariesV2/Beneficiaries';
import DividendsAndCapitalGainsV2 from 'components/layouts/Preferences/DividendsAndCapitalGains/DividendsAndCapitalGains';
import CostBasisMethodV2 from 'components/layouts/Preferences/CostBasisMethod/CostBasisMethod';
import MessageCenterLayout from 'components/layouts/MessageCenterLayout';
import PreferencesMain from 'components/layouts/Preferences/PreferencesMain';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import AlertsAndNotifications from 'components/layouts/Preferences/AlertsAndNotifications/AlertsAndNotifications';
import AlertsComingSoon from 'components/pages/Utilities/AlertsComingSoon';
import PaperlessPreferences from 'components/layouts/Preferences/PaperlessPreferences/PaperlessPreferences';
import ProfileMaintenance from 'components/layouts/Preferences/ProfileMaintenance';

const PreferencesNavigationContainer = ({
  isSalesforceRepEnabled,
  hasError,
  requestStatesKey
}) => {
  return (
    <div
      className={
        !isSalesforceRepEnabled
          ? 'preferences-container'
          : 'preferences-container-sf'
      }>
      <PageLoadingContainer
        hasError={hasError}
        name="Profile"
        requestStates={requestStateConfig[requestStatesKey]}>
        <Switch>
          <Route
            component={
              grantViewAccessEnabled() ? GrantViewAccess : ProfileMaintenance
            }
            path="/profile/grant-view-access"
          />
          <Route
            component={PreferencesUpdateContactInformation}
            path="/profile/contact-information"
          />
          <Route component={TrustedContacts} path="/profile/trusted-contacts" />
          <Route
            component={
              beneficiariesEnabled() ? BeneficiariesV2 : Beneficiaries
            }
            path="/profile/beneficiaries"
          />
          <Route
            component={LinkedBankAccounts}
            path="/profile/linked-bank-accounts"
          />
          <Route
            component={CostBasisMethodV2}
            path="/profile/cost-basis"
          />
          <Route
            component={PreferencesCheckwriting}
            path="/profile/checkwriting"
          />
          <Route
            component={CustomizeAccountsView}
            path="/profile/customize-account-view"
          />
          <Route
            component={DividendsAndCapitalGainsV2}
            path="/profile/dividends-and-capital-gains"
          />
          <Route
            component={
              paperlessPageEnabled() ? PaperlessPreferences : DocumentDelivery
            }
            path="/profile/document-delivery"
          />
          <Route
            component={
              GPCSubscriptionsEnabled() ? GPCSubscriptions : Subscriptions
            }
            path="/profile/subscriptions"
          />
          <Route
            component={
              alertsAndNotificationsEnabled()
                ? AlertsAndNotifications
                : AlertsComingSoon
            }
            path="/profile/alerts-and-notifications"
          />
          <Route component={MessageCenterLayout} path="/message-center" />
          <Route component={ErrorPage} path="*/error" />
          <Route component={PreferencesMain} path="/profile" />
        </Switch>
      </PageLoadingContainer>
    </div>
  );
};

PreferencesNavigationContainer.propTypes = {
  hasError: bool.isRequired,
  requestStatesKey: string.isRequired
};

const mapStateToProps = (state) => ({
  requestStatesKey: getLocationRequestStateKey(state)
});

export default connect(mapStateToProps)(PreferencesNavigationContainer);
